import './About.css';
import './about-history';
import AboutHistory from './about-history';
import NationalTeam from '../components/National-team';
import BackgroundDisplay from '../components/background-display';
import ExecutiveCouncil from './executiveCouncil';
const About = () => {
    return ( 
        <>
        <BackgroundDisplay title='About ORIDSAN'/>
        <div className='my-about-container'>
          <AboutHistory/>
          <ExecutiveCouncil/>
          <NationalTeam/>
         
        </div>
        </>
     );
}
 
export default About;